import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterBikes from '../components/MasterBikes';

const MasterBikesPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterBikes user={user} />;
};

export default MasterBikesPage;
